/* import __COLOCATED_TEMPLATE__ from './prism-file-input.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';

/**
 * This component opens a browser default file select window, then sets
 * the value of the component to the first file selected.
 *
 * This component does not currently support multiple file selecting,
 * but could probably easily be altered to do so.
 *
 * @class PrismFileInput
 */
export default Component.extend({
  tagName: '',
  /**
   * ID to apply to the underlying input field.
   *
   * @argument inputId
   * @type {String}
   */
  inputId: null,
  /**
   * An action handler that is called by the component
   * once the user has selected a file from the operating
   * system. The action should do something with the file
   * object that is returned.
   *
   * @argument onChange
   * @type {Action}
   */
  onChange() {},
  /**
   * An action handler that is called by the component
   * when it is clicked and opening the browser file
   * upload window.
   *
   * @argument fileInputClicked
   * @type {Action}
   */
  fileInputClicked() {},
  /**
   * An array of string file types supported by the input. Defaults to []
   * which allows all file types.
   *
   * @argument fileTypeWhitelist
   * @type {Array<String>}
   */
  fileTypeWhitelist: null,
  /**
   * @argument uploadPromptText
   * @type {String}
   */
  uploadPromptText: null,
  /**
   * @argument textClass
   * @type {String}
   */
  textClass: null,
  /**
   * @argument iconClass
   * @type {String}
   */
  iconClass: null,
  /**
   * @argument useRounded
   * @type {Boolean}
   */
  useRounded: false,
  fileTypeWhitelistString: computed('fileTypeWhitelist.length', function () {
    return (this.fileTypeWhitelist || []).join();
  }),
  _onChange(event) {
    // Ember events propagate differently in test and dev environments
    const files = event.target.files || event.files;
    if (!files[0]) {
      return;
    }
    this.onChange(files[0]);
  }
});